export const RENDER_MODE = Object.freeze({
  CREATE: "create",
  EDIT: "edit",
  DETAIL: "detail",
  CARD: "card",
  GRID: "grid",
});

export const READ_ONLY_RENDER_MODES = Object.freeze([
  RENDER_MODE.CARD,
  RENDER_MODE.GRID,
]);
